var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"size":"sm","centered":""}},[_c('form',{ref:"form",on:{"submit":_vm.save}},[_c('fields',{attrs:{"fields":_vm.fields.all(),"model":_vm.model,"errors":_vm.errors,"layout":"vertical"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }